import type { AchievementFragment } from '@lingoda/graphql';

export const getAchieved = ({ currentProgress, value }: AchievementFragment) =>
    currentProgress >= value;
